/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Deletemodal from "./DeleteModal";
import Page from "src/components/Page";
import {
  Button,
  Card,
  CircularProgress,
  Container,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { Add, ArrowLeft, DeleteSharp, EditSharp, UploadFile } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { notification } from "src/utils/messages";
import { Routes } from "src/constant/api_url";
import { DateTimePicker, LocalizationProvider } from "@mui/lab";
import { PollSelect } from "src/utils/common";
import styled from "styled-components";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import Select from "react-select";
import { deletetOBT, getAllOBTlist, insertOBT, updateOBT } from "src/api/commonapi";
import { CSVLink } from "react-csv";
import Label from "src/components/Label";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function OBTAdd() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [page, setPage] = useState(0);
  const [option, setOption] = useState(null);
  const [setfile, setFile] = useState({});
  const [fileimage, setfileimage] = useState();
  const [newOBTDataList, setNewOBTDataList] = useState([]);
  const [obtDataList, setOBTDataList] = useState([]);
  const [response, setresponse] = useState(0);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  const [isLoading, setIsLoading] = useState(false);

  const getOptionsValueList = async (type = 0) => {
    let optionData = [];
    if (type != 0) {
      const resp = await PollSelect(type, loginUser?.u_type, loginUser?.city_id);
      resp?.map((e) => optionData.push({ value: e.value, label: e.name }));
      setOption([{ value: 0, label: "Select" }, ...optionData]);
    }
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
  });

  const [formData, setFormData] = useState({
    obt_img: "",
    obt_title: "",
    obt_desc: "",
    obt_link: "",
    obt_sdate: "",
    obt_edate: "",
    obt_send_to: "0",
    obt_for_type: "0", // 0 - LVB , 1- State, 2- City, 3- Chapter
    obt_for_type_id: ""
  });

  const resetFormData = () => {
    setFormData({
      obt_img: "",
      obt_title: "",
      obt_desc: "",
      obt_link: "",
      obt_sdate: "",
      obt_edate: "",
      obt_send_to: "0",
      obt_for_type: "0",
      obt_for_type_id: ""
    });
  };

  const OBTForList =
    loginUser?.u_type === 1
      ? [
          { label: "All", value: -1 },
          { label: "City", value: 2 },
          { label: "Chapter", value: 3 }
        ]
      : [
          { label: "All", value: -1 },
          { label: "LVB", value: 0 },
          { label: "State", value: 1 },
          { label: "City", value: 2 },
          { label: "Chapter", value: 3 }
        ];

  const OBTStatusList = [
    { label: "All", value: 0 },
    { label: "Open ", value: 1 },
    { label: "Expired", value: 2 }
  ];

  const [filtereddata, setFilteredData] = useState({
    OBTFor: -1,
    OBTStatus: 0,
    search: "",
    startDate: "",
    endDate: ""
  });

  const handleFormSubmit = async (newData = undefined) => {
    try {
      let fData = new FormData();

      if (formData != undefined && formData.obt_id != undefined) {
        fData.append("obt_title", formData.obt_title);
        fData.append("obt_desc", formData.obt_desc);
        fData.append("obt_img", setfile.file);
        fData.append("obt_link", formData.obt_link);
        fData.append("obt_sdate", formData.obt_sdate);
        fData.append("obt_edate", formData.obt_edate);
        fData.append("obt_send_to", formData.obt_send_to);
        fData.append("obt_for_type", formData.obt_for_type);
        fData.append("obt_for_type_id", formData.obt_for_type_id);
        fData.append("obt_id", formData.obt_id);

        setIsLoading(true);
        const resp = await updateOBT(fData);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        if (resp.status == 1) {
          notify();
          resetFormData();
          setPage(0);
          getOBTDataList();
          setFile({});
          setfileimage();
        } else {
          notify();
        }
      } else {
        // Insert the form data
        if (
          // !setfile ||
          // Object.keys(setfile).length === 0 ||
          // !setfile.file ||
          formData.obt_title == "" ||
          formData.obt_desc == "" ||
          // formData.obt_link == "" ||
          formData.obt_sdate == "" ||
          formData.obt_edate == "" ||
          formData.obt_send_to == "" ||
          formData.obt_for_type == "" ||
          (formData.obt_for_type != 0 && formData.obt_for_type_id == "")
        ) {
          let notify = notification({
            type: "error",
            message: "Please enter all required fields to submit"
          });
          notify();
        } else {
          // API Call
          fData.append("obt_title", formData.obt_title);
          fData.append("obt_desc", formData.obt_desc);
          fData.append("obt_img", setfile.file);
          fData.append("obt_link", formData.obt_link);
          fData.append("obt_sdate", formData.obt_sdate);
          fData.append("obt_edate", formData.obt_edate);
          fData.append("obt_send_to", formData.obt_send_to);
          fData.append("obt_for_type", formData.obt_for_type);
          fData.append("obt_for_type_id", formData.obt_for_type_id);

          setIsLoading(true);
          const resp = await insertOBT(fData);
          setIsLoading(false);
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          if (resp.status == 1) {
            notify();
            resetFormData();
            setPage(0);
            getOBTDataList();
            setFile({});
            setfileimage();
          } else {
            notify();
          }
        }
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const obtDataDelete = async (obt_id) => {
    const resp = await deletetOBT(obt_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  // const getOBTDataList = async () => {
  //   let resp = await getAllOBTlist(loginUser.city_id, loginUser.u_type);
  //   setOBTDataList(resp.data);
  // };

  const getOBTDataList = async () => {
    setIsLoading(true);
    let resp = await getAllOBTlist(loginUser.city_id, loginUser.u_type);
    setIsLoading(false);

    const updatedList = resp.data.map((item) => {
      const startDate = moment(item.obt_sdate, "DD-MM-YYYY hh:mm A");
      const now = moment();
      const isExpired = now.isAfter(startDate.clone().add(3, "months"));

      return {
        ...item,
        computed_status: isExpired ? "Expired" : "Open"
      };
    });

    setOBTDataList(updatedList);
  };

  useEffect(async () => {
    getOBTDataList();
  }, [response]);

  const expo_columns = [
    { label: "No", key: "obt_id" },
    { label: "Title", key: "obt_title" },
    { label: "Description", key: "obt_desc" },
    { label: "URL", key: "obt_link" },
    { label: "OBT Send To", key: "OBT_Send_To" },
    { label: "OBT For", key: "OBT_For" },
    { label: "Start Date", key: "obt_sdate" },
    { label: "End Date", key: "obt_edate" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.obt_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Image",
      wrap: true,
      width: "150px",
      cell: (row) => {
        return row.obt_img ? (
          <img src={`${Routes.API_HOSTNAME}images/obt/${row.obt_img}`} alt="img" width="100" />
        ) : (
          "-"
        );
      }
    },
    {
      name: "Title",
      wrap: true,
      width: "200px",
      selector: (row) => (row.obt_title != null && row.obt_title != "" ? row.obt_title : "-"),
      sortable: true
    },
    {
      name: "URL",
      wrap: true,
      width: "150px",
      selector: (row) => ((row.obt_link != null) & (row.obt_link != "") ? row.obt_link : "-"),
      sortable: true
    },
    {
      name: "OBT Send To",
      width: "130px",
      wrap: true,
      selector: (row) => row.OBT_Send_To
    },
    {
      name: "OBT For",
      width: "130px",
      wrap: true,
      selector: (row) => row.OBT_For
    },
    {
      name: "Location",
      wrap: true,
      width: "100px",

      selector: (row) =>
        loginUser.u_type != 0
          ? row.city_name
          : row.obt_for_type == 1
            ? row.s_name
            : row.obt_for_type == 2
              ? row.city_name
              : row.obt_for_type == 3
                ? row.ch_name
                : "LVB"
    },
    {
      name: "Created Date",
      width: "110px",
      wrap: true,
      selector: (row) => row.obt_created
    },
    {
      name: "Start Date",
      wrap: true,
      width: "120px",
      selector: (row) => row.obt_sdate,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.obt_edate,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "OBT Status",
      wrap: true,
      width: "100px",
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.computed_status === "Open" ? "success" : "error"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.computed_status}
        </Label>
      ),
      sortable: false
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => {
              setPage(2);
              setFormData(row);
              getOptionsValueList(row.obt_for_type);
              setfileimage();
              setFile({});
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => {
              setDvisible({ mval: true, id: row.obt_id });
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </button>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        <p>
          <b>Description</b> : {data?.obt_desc}
        </p>
      </div>
    );
  };

  const filterData = () => {
    const filterByType = (obt) => {
      return filtereddata.OBTFor == -1 || obt.obt_for_type === filtereddata.OBTFor;
    };

    const filterByOpenClose = (obt) => {
      if (filtereddata.OBTStatus === 1) {
        // Open OBT
        return obt.computed_status === "Open";
      }
      if (filtereddata.OBTStatus === 2) {
        // Expired OBT
        return obt.computed_status === "Expired";
      }
      return true;
    };

    const filterBySearchType = (obt) => {
      let searchFilterText = filtereddata.search.toLowerCase();
      return (
        filtereddata.search == "" ||
        obt?.obt_title?.toLowerCase().includes(searchFilterText) ||
        obt?.obt_desc?.toLowerCase().includes(searchFilterText) ||
        obt?.OBT_For?.toLowerCase().includes(searchFilterText) ||
        obt?.obt_link?.toLowerCase().includes(searchFilterText)
      );
    };

    const nOBT = obtDataList.filter(
      (obt) => filterByType(obt) && filterByOpenClose(obt) && filterBySearchType(obt)
    );

    setNewOBTDataList(nOBT);
  };

  useEffect(() => {
    filterData();
  }, [filtereddata, obtDataList]);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={obtDataDelete} />
      <Page title="On Boarding Training | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              On Boarding Training
            </Typography>
            {page === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  resetFormData();
                  setFile({});
                  setfileimage(); // Clear the image preview
                  setPage(1);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add OBT
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  resetFormData();
                  setPage(0);
                  setfileimage();
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {page !== 0 ? (
            <>
              <Card style={{ padding: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormLabel>OBT Send to</FormLabel>
                    <Stack spacing={3}>
                      <RadioGroup
                        style={{ marginTop: "0px" }}
                        row
                        defaultValue={0}
                        value={formData?.obt_send_to}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            obt_send_to: e.target.value
                          });
                        }}
                        name="obt_send_to"
                      >
                        <FormControlLabel value="0" control={<Radio />} label="All" />
                        <FormControlLabel value="1" control={<Radio />} label="LT" />
                        <FormControlLabel value="2" control={<Radio />} label="Members" />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel id="demo-radio-buttons-group-label">OBT For</FormLabel>
                    <Stack spacing={3}>
                      <RadioGroup
                        style={{ marginTop: "0px" }}
                        row
                        defaultValue={0}
                        value={formData?.obt_for_type}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            obt_for_type: e.target.value,
                            obt_for_type_id: ""
                          });
                          getOptionsValueList(e.target.value);
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="obt_for_type"
                      >
                        {loginUser?.u_type === 0 && (
                          <>
                            <FormControlLabel value="0" control={<Radio />} label="LVB" />
                            <FormControlLabel value="1" control={<Radio />} label="State" />
                          </>
                        )}
                        <FormControlLabel value="2" control={<Radio />} label="City" />
                        <FormControlLabel value="3" control={<Radio />} label="Chapter" />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  {formData.obt_for_type != 0 ? (
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>
                          Select
                          {formData?.obt_for_type == 1
                            ? " State"
                            : formData?.obt_for_type == 2
                              ? " City"
                              : formData?.obt_for_type == 3
                                ? " Chapter"
                                : " LVB"}
                        </label>
                        <Select
                          required={true}
                          error={true}
                          style={{ marginTop: "0px" }}
                          value={
                            option != null &&
                            option.map((c) => {
                              if (c.value === formData?.obt_for_type_id) {
                                return { value: c.value, label: c.label };
                              }
                            })
                          }
                          onChange={(e) => {
                            setFormData({ ...formData, obt_for_type_id: e.value });
                          }}
                          menuPortalTarget={document.body}
                          options={option}
                        />
                      </Stack>
                    </Grid>
                  ) : (
                    ""
                  )}

                  <Grid item xs={12}>
                    <Button
                      component="label"
                      variant="contained"
                      color="primary"
                      tabIndex={-1}
                      sx={{ textTransform: "none", p: "10px" }}
                      startIcon={<UploadFile />}
                    >
                      Click to Upload file (Optional)
                      <VisuallyHiddenInput
                        type="file"
                        required
                        multiple={false}
                        accept="image/*,.jpg,.jpeg,.png,.gif"
                        onChange={(event) => {
                          const uploadedFile = event.currentTarget.files[0];

                          // Check if file exists and validate its size
                          if (uploadedFile && uploadedFile.size > 2097152) {
                            let notify = notification({
                              type: "error",
                              message: "File size exceeds 2MB. Please upload a smaller file."
                            });
                            notify();
                            return;
                          }

                          // If valid, update the state
                          setFile({ file: uploadedFile });
                          setfileimage(URL.createObjectURL(uploadedFile));
                        }}
                      />
                    </Button>

                    {/* Display uploaded Image */}
                    {page === 1 &&
                      (fileimage !== undefined ? (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={fileimage}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      ))}
                    {page === 2 &&
                      (fileimage !== undefined ? (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={fileimage}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ) : formData?.obt_img !== null ? (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={`${Routes.API_HOSTNAME}images/obt/${formData?.obt_img}`}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      ))}
                  </Grid>

                  <Grid item xs={12}>
                    <Stack spacing={3}>
                      <TextField
                        required
                        type="text"
                        label="Title"
                        fullWidth
                        value={formData?.obt_title}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            obt_title: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Description"
                      required
                      multiline
                      fullWidth
                      rows={4}
                      value={formData?.obt_desc}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          obt_desc: e.target.value
                        });
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Stack spacing={3}>
                      <TextField
                        type="text"
                        label="URL"
                        fullWidth
                        value={formData?.obt_link}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            obt_link: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  {/* grid 6 add start date and end date */}
                  <Grid item xs={6}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "20px" }}
                      >
                        <DateTimePicker
                          type="date"
                          name="obt_sdate"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy hh:mm a"
                          value={
                            formData.obt_sdate !== ""
                              ? moment(formData.obt_sdate, "DD-MM-YYYY hh:mm A").toDate()
                              : null
                          }
                          onChange={(newDate) => {
                            setFormData({
                              ...formData,
                              obt_sdate: moment(newDate).format("DD-MM-YYYY hh:mm A")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} required />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "20px" }}
                      >
                        <DateTimePicker
                          type="date"
                          name="obt_edate"
                          label="End Date "
                          inputFormat="dd/MM/yyyy hh:mm a"
                          value={
                            formData.obt_edate != ""
                              ? moment(formData.obt_edate, "DD-MM-YYYY hh:mm A").toDate()
                              : null
                          }
                          onChange={(newDate) => {
                            setFormData({
                              ...formData,
                              obt_edate: moment(newDate).format("DD-MM-YYYY hh:mm A")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} required />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>

                  {/* submit and rest form state */}
                  <Grid item xs={12} spacing={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ marginRight: "5px" }}
                      onClick={() => handleFormSubmit()} // handleFormSubmit function
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        resetFormData();
                        setPage(0);
                        setfileimage();
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </>
          ) : (
            <>
              <Card className="p-20 mb-15">
                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={3}>
                    <Stack sx={{ my: "5px" }}>
                      <label>OBT For</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={OBTForList.map((c) => {
                          if (c.value == filtereddata.OBTFor) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            OBTFor: e.value
                          });
                        }}
                        options={OBTForList}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack>
                      <label>OBT Status</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={OBTStatusList.map((c) => {
                          if (c.value == filtereddata.OBTStatus) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            OBTStatus: e.value
                          });
                        }}
                        options={OBTStatusList}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={4}>
                    <Stack spacing={10}>
                      <TextField
                        style={{ marginTop: "20px" }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        label="Search"
                        name="name"
                        size="small"
                        autoCorrect="off"
                        value={filtereddata.search}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            search: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                      marginTop: "20px"
                    }}
                  >
                    <Button
                      onClick={async () => {
                        setFilteredData({
                          OBTFor: -1,
                          OBTStatus: 0,
                          search: "",
                          startDate: "",
                          endDate: ""
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              <Card className="p-2" style={{ padding: "15px" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={newOBTDataList}
                    headers={expo_columns}
                    filename={"On Boarding Training.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {obtDataList && (
                  <>
                    <DataTable
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={newOBTDataList != null && newOBTDataList}
                      expandableRows
                      expandableRowsComponent={ExpandableRow}
                      progressPending={isLoading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
